import { Logo, Mark } from "../lib/logo";
import { logoMarki } from "../lib/marka";
import type { Motyw } from "./Motyw";
import type { Branding } from "../types";

/**
 * Znak marki w procesie kandydata: logo z szablonu albo lockup for apps.
 *
 * Logo marki to obrazek o własnych proporcjach (City Drive jest wysoki,
 * Udriver szeroki), więc nie skalujemy go jednym rozmiarem — siedzi w polu
 * o stałej wysokości i maksymalnej szerokości, a `object-fit` pilnuje
 * proporcji. Wersja na ciemne tło wchodzi w motywie ciemnym; bez niej
 * zostaje jasna (lepsze to niż pusty nagłówek).
 */
export function LogoMarki({
  branding,
  motyw,
  miejsce,
}: {
  branding?: Branding | null;
  motyw: Motyw;
  /** `pasek` — nagłówek na telefonie, `kolumna` — lewa kolumna na szerokim ekranie. */
  miejsce: "pasek" | "kolumna";
}) {
  const ciemny = motyw === "dark";
  const src = logoMarki(branding, ciemny);

  if (src && branding) {
    const obraz = <img className={`marka-logo marka-logo--${miejsce}`} src={src} alt={branding.name} />;
    return miejsce === "pasek" ? <span className="brand">{obraz}</span> : obraz;
  }

  // Karta logo zabrania czerwonego sygnetu na ciemnym tle — stąd wariant.
  const wariant = ciemny ? "reverse" : "primary";
  if (miejsce === "pasek") {
    // Pełny lockup marki — słowo „for apps" zamiast etykiety produktu;
    // zapis małymi literami pilnuje tokens.css (karta logo).
    return <Logo size={18} className="brand" wariant={wariant} />;
  }
  return (
    <>
      <Mark size={22} wariant={wariant} />
      <span className="logo__slowo">for apps</span>
    </>
  );
}
